;(function ( $ ) {

    /**
     *  optIn
     *  checks if user has confirmed opt in and forwards to linked form or displays opt-in dialog
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'optIn';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.optIn = $('body').data('opt-in');
            if (this.optIn === true) {
                window.optInOrderTerms = true;
                // nothing to do, user has already opted-in
                return;
            }
            window.optInOrderTerms = false;
            this.optInUrl = $('body').data('opt-in-url');
            if (!this.optInUrl) {
                return;
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
